import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"input l-fill input-number \" this._internalIsInvalid \" \" this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} pattern=\"\\d*\\.?\\d*\" />", {
  moduleName: "@dashboard/shared-ui/components/sq-input-fractional-quantity.hbs"
});